import * as React from 'react';
import {EmitterSubscription, Keyboard, Platform} from 'react-native';

export const useIsKeyboardShown = () => {
  const [isKeyboardShown, setIsKeyboardShown] = React.useState(false);
  React.useEffect(() => {
    const handleKeyboardShow = () => setIsKeyboardShown(true);

    const handleKeyboardHide = () => setIsKeyboardShown(false);
    let keybordShow: EmitterSubscription | null = null;
    let keyboardHide: EmitterSubscription | null = null;
    if (Platform.OS === 'ios') {
      keybordShow = Keyboard.addListener('keyboardWillShow', handleKeyboardShow);
      keyboardHide = Keyboard.addListener('keyboardWillHide', handleKeyboardHide);
    } else {
      keybordShow = Keyboard.addListener('keyboardDidShow', handleKeyboardShow);
      keyboardHide = Keyboard.addListener('keyboardDidHide', handleKeyboardHide);
    }

    return () => {
      keybordShow?.remove();
      keyboardHide?.remove();
    };
  }, []);
  return isKeyboardShown;
};
